import { Component, Input, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  badgePosition,
  ButtonColor,
  ButtonStyle,
  ButtonVariant,
  IButton,
  Icon,
  TypeStyle,
} from '../../../base/src/abcButton/abcButton';

@Component({
  selector: '',
  template: `
    <button
      #matButton
      mat-button
      [matBadge]="badge"
      [matBadgePosition]="badgePosition"
      [ngClass]="stylingMode + ' ' + class"
      id="{{ id }}"
      [color]="color !== 'basic' ? color : ''"
      [style.width]="width"
      [style.height]="height"
      [disabled]="color === 'disabled' ? disabled : false"
      style="background-color:{{ buttonBackgroundColor }}"
    >
      <div style="display: flex;align-items: center;justify-content: center;">
        <span *ngIf="icon">
          <mat-icon
            style="vertical-align: middle;margin-right:7px;color: {{ iconColor }};background-color:{{
              iconBackgroundColor
            }}"
            >{{ icon }}</mat-icon
          >
        </span>
        <img *ngIf="image" src="{{ image }}" style="height:16px;width:16px;margin-right:7px;vertical-align: middle;" />
        <span>{{ value }}</span>
      </div>
    </button>
  `,
})
export class MatButtonComponent implements IButton {
  @Input() id: string;
  @Input() color: ButtonColor;
  @Input() buttonBackgroundColor: string;
  @Input() stylingMode: ButtonVariant = ButtonVariant.Basic;
  @Input() variant: string;
  @Input() value: string;
  @Input() image: string;
  @Input() icon: Icon;
  @Input() disabled: boolean;
  @Input() height: string;
  @Input() width: string;
  @ViewChild('matButton', { static: true }) matButton: MatButton;
  @Input() class?: string;
  @Input() iconColor: string;
  @Input() iconBackgroundColor: string;
  @Input() badge: number;
  @Input() badgePosition: badgePosition;
  @Input() badgeColor: string;

  constructor() {}

  callBackFN?: any;
  visible?: boolean;
  hint?: string;
  focusStateEnabled?: boolean;
  hoverStateEnabled?: boolean;
  rtlEnabled?: boolean;
  text?: string;
  type?: TypeStyle;

  setButtonStyle(style: ButtonStyle): void {
    const element = this.matButton?._elementRef?.nativeElement;
    if (style) {
      for (let key in style) {
        element.style[key] = style[key];
      }
    }
  }

  setCustomDataAttributes(data: Object): void {
    const element = this.matButton._elementRef.nativeElement;
    if (data) {
      for (let key in data) {
        element.setAttribute(key, data[key]);
      }
    }
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    const element: HTMLElement = this.matButton._elementRef.nativeElement;
    element.addEventListener(type, listener, options);
  }
}
